<template>
    <InactivityModal
        class="inactivity-alert"
        :isOpen="acc_inactive"
        :title="'INACTIVITY ALERT'"
        :buttonText="'Logout'"
        @close="handleCloseInactivityModal"
        @submit="handleInactivityLogout"
    >
        <div class="modal-table-container">
            You have been inactive for the already 10 minutes. Do you want to
            stay logged in ?
        </div>
    </InactivityModal>
    <div
        :class="[
            'main-container',
            { loggedIn: isLoggedIn, 'dark-mode': isDarkMode },
        ]"
    >
        <HeaderView v-if="showHeader" />
        <div :class="['row content-container', { 'full-width': isOpenAside }]">
            <div class="col d-flex">
                <AsideView v-if="isLoggedIn && !isGuest" />
            </div>
            <div
                :class="[
                    'page-container',
                    {
                        'full-width': isOpenAside || !isLoggedIn,
                        'dark-mode': isDarkMode,
                    },
                ]"
            >
                <RouterView />
            </div>
        </div>
        <FooterView v-if="showFooter" />
    </div>
    <div
        v-if="
            !chatVisible &&
            this.$route.path !== '/login' &&
            (this.isGuest || !this.isLoggedIn)
        "
        class="chat-with-agent d-flex align-items-center justify-content-center"
        @click="toggleChatWindow"
    >
        <div class="d-flex flex-column align-items-center gap-1">
            <font-awesome-icon icon="comment-dots" class="comment-icon" />
            <span class="section-title mb-0 fw-normal" style="font-size: 13px">
                Chat
            </span>
        </div>
    </div>
    <ChatModal
        :isOpen="
            chatVisible &&
            this.$route.path !== '/login' &&
            (this.isGuest || !this.isLoggedIn)
        "
        @close="toggleChatWindow"
    >
    </ChatModal>
</template>

<script>
import HeaderView from "./components/common/header/HeaderView";
import AsideView from "./components/common/aside/AsideView";
import FooterView from "./components/common/footer/FooterView";
import InactivityModal from "./components/common/modal/ModalView.vue";
import ChatModal from "./components/chat/chatagent/ChatAgentView.vue";
import apiHelper from "@/utils/apiHelpers";
import { mapState } from "vuex";

export default {
    components: {
        HeaderView,
        FooterView,
        AsideView,
        InactivityModal,
        ChatModal,
    },
    data() {
        return {
            acc_inactive: false,
            buttonText: "Logout",
            path: "",
            chatVisible: false,
            chatMsg: {
                from: "",
                subject: "",
                masg: "",
            },
        };
    },
    computed: {
        ...mapState(["loggedUser", "isLoggedIn", "isOpenAside", "isDarkMode"]),
        showFooter() {
            const _show = !this.isLoggedIn || (this.isLoggedIn && this.isGuest);
            return _show;
        },
        showHeader() {
            return this.$route.path !== "/login";
        },
    },
    watch: {
        isLoggedIn(newValue) {
            if (newValue) {
                this.toggleChatWindow();
                if (!this.isGuest) {
                    this.startInactivityHandler(); // Start inactivity checker on login
                }
            } else {
                this.stopInactivityHandler(); // Stop it on logout
            }
        },
    },
    methods: {
        async startInactivityHandler() {
            const resetTimer = () => {
                clearTimeout(this.inactivityTimer);
                this.inactivityTimer = setTimeout(() => {
                    this.acc_inactive = true;
                }, 10 * 60 * 1000); // 10 minutes
            };
            const events = ["mousemove", "keydown", "click", "scroll"];
            events.forEach((event) =>
                window.addEventListener(event, resetTimer),
            );
            resetTimer();
            // Store event listeners for removal later
            this.inactivityEvents = events.map((event) => ({
                event,
                handler: resetTimer,
            }));
        },
        async stopInactivityHandler() {
            // Clear timer and remove event listeners
            clearTimeout(this.inactivityTimer);
            if (this.inactivityEvents) {
                this.inactivityEvents.forEach(({ event, handler }) =>
                    window.removeEventListener(event, handler),
                );
            }
        },
        async handleInactivityLogout() {
            this.acc_inactive = false;
            await apiHelper.logout(this.$router, this.loggedUser.timelog_id);
        },
        async handleCloseInactivityModal() {
            this.acc_inactive = !this.acc_inactive;
        },
        async updateLoggedUserInfo() {
            const uid = this.$store.state.loggedUser.id;
            const response = await apiHelper.getInfoById(
                `/users/${uid}`,
                this.$router,
            );
            if (response.success) {
                this.$store.state.loggedUser.user_name =
                    response.user.user_name;
                this.$store.state.loggedUser.first_name =
                    response.user.first_name;
                this.$store.state.loggedUser.last_name =
                    response.user.last_name;
                this.$store.state.loggedUser.can_avail_discount =
                    response.user.can_avail_discount;
            } else {
                throw new Error("Unsuccessful response");
            }
        },
        toggleChatWindow() {
            this.chatVisible = !this.chatVisible;
        },
    },
    mounted() {
        if (
            this.isLoggedIn &&
            this.loggedUser.user_roles.some(
                (role) => role.id !== 1 || role.id !== 2,
            ) &&
            this.validToken
        ) {
            if (!this.isGuest) {
                this.startInactivityHandler(); // Start inactivity checker if already logged in
            }
            this.updateLoggedUserInfo();
        }
    },
    beforeUnmount() {
        this.stopInactivityHandler(); // Clean up on component unmount
    },
};
</script>
